import axios, { AxiosResponse } from "axios";

import { BookingFilterByCustomers } from "@assets/constants";
import { BookingTemplateTypes, SamskipAPIResponse } from "@assets/types";

const SamskipAPI = process.env.SamskipAPI;

class BookingTemplateService {
  createTemplate = async (
    template: BookingTemplateTypes.CreateUpdateBookingTemplate
  ) => {
    const res: AxiosResponse<number> = await axios.post(
      `${SamskipAPI}/templates/booking`,
      template,
      {
        withCredentials: true,
      }
    );
    return res.data;
  };

  updateTemplate = async (
    bookingTemplateId: number,
    template: BookingTemplateTypes.CreateUpdateBookingTemplate
  ) => {
    const res: AxiosResponse<
      SamskipAPIResponse<BookingTemplateTypes.BookingTemplate>
    > = await axios.put(
      `${SamskipAPI}/templates/bookings/${encodeURIComponent(
        bookingTemplateId
      )}`,
      template,
      {
        withCredentials: true,
      }
    );
    return res.data;
  };

  getTemplate = async (bookingTemplateId: number) => {
    const res: AxiosResponse<
      SamskipAPIResponse<BookingTemplateTypes.BookingTemplate>
    > = await axios.get(
      `${SamskipAPI}/templates/bookings/${bookingTemplateId}`,
      {
        withCredentials: true,
      }
    );
    return res.data.ReturnItem.Data;
  };

  getTemplates = async (filters: BookingTemplateTypes.TemplateFilter) => {
    const res: AxiosResponse<
      SamskipAPIResponse<BookingTemplateTypes.BookingTemplateData>
    > = await axios.get(`${SamskipAPI}/templates/bookings/search`, {
      params: {
        ...filters,
      },
      paramsSerializer: {
        indexes: null,
      },
      withCredentials: true,
    });
    return res.data.ReturnItem.Data;
  };

  disableTemplate = async (bookingTemplateId: number) => {
    const res: AxiosResponse<number> = await axios.patch(
      `${SamskipAPI}/templates/bookings/${encodeURIComponent(
        bookingTemplateId
      )}/disable`,
      undefined,
      { withCredentials: true }
    );
    return res;
  };

  getTemplatePartnersFilterValues = async (
    templateCustomer: BookingFilterByCustomers
  ) => {
    const res: AxiosResponse<
      SamskipAPIResponse<BookingTemplateTypes.BookingTemplatePartnersFilterValues>
    > = await axios.get(`${SamskipAPI}/templates/bookings/partners-filters`, {
      withCredentials: true,
      params: {
        templateCustomer: templateCustomer,
      },
    });
    return res.data.ReturnItem.Data;
  };
}

export default new BookingTemplateService();
